import Carousel from './Carousel'

const productRecommendationsSection = document.querySelector('.product-recirculation')

const url = productRecommendationsSection.dataset.url

fetch(url).then(response => response.text()).then(text => {
    const html = document.createElement('div')
    html.innerHTML = text
    const recommendations = html.querySelector('.product-recirculation')
    const slides = Array.from(recommendations.querySelectorAll('.slider-slides .slide'))

    if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML
    }

    const slider = productRecommendationsSection.querySelector('[data-carousel]')

    if (slides.length > 0) {
        productRecommendationsSection.classList.remove('hidden')
        productRecommendationsSection.classList.add('grid')
    }

    const carousel = new Carousel(slider)

    // slider.carousel.init()
}).catch(e => {
    console.error(e)
})
